export const LISTA_TOOLBAR_SEARCH_PLACEHOLDER = "Buscar Obra";
export const LISTA_TOOLBAR_SEARCH_MAX_LENGTH = 500;

export const LISTA_TOOLBAR_VIEW_OPTIONS = [
  { mode: "lista", label: "Lista" },
  { mode: "cards", label: "Cards" },
] as const;
